import { Component, Input, OnInit } from '@angular/core';

import { EntityModel } from 'src/app/model';
import { EntitiesServiceService } from 'src/app/shared/services';

@Component({
  selector: 'app-tile-body',
  templateUrl: './tile-body.component.html',
  styleUrls: ['./tile-body.component.css']
})
export class TileBodyComponent implements OnInit {

  @Input() content: EntityModel;

  @Input() pageType: 'people' | 'assets' | 'vehicles';

  constructor(public service: EntitiesServiceService) { }

  ngOnInit(): void { } 
}
